import { SetStateAction, useState } from 'react';
import { useInput, useRecordContext } from 'react-admin';
//https://casesandberg.github.io/react-color/
import { CompactPicker as CPicker } from 'react-color';

interface IProps {
  label: string;
  help?: string;
  source: string;
}
export const ColorPicker = (props: IProps) => {
  const record = useRecordContext();
  const [color, setColor] = useState<string>(record?.[props.source] || '#fff');
  const {
    field: { onChange },
  } = useInput(props);

  const handleChangeComplete = (clr: { hex: SetStateAction<string> }) => {
    setColor(clr.hex);
    onChange(clr.hex);
  };

  return (
    <>
      <div>
        <b style={{ fontSize: '1.5em' }}>{props.label}:</b>: {props.help}
      </div>
      <br />
      <CPicker color={color} onChangeComplete={handleChangeComplete} />
      <hr /> <hr />
    </>
  );
};
